const zbagTicketTypes = {
  SKIPASS_ZERMATT: 'SKIPASS_ZERMATT',
  SKIPASS_INTERNATIONAL: 'SKIPASS_INTERNATIONAL',
  SKIPASS_ZERMATT_SHUTTLE: 'SKIPASS_ZERMATT_SHUTTLE',
  SKIPASS_INTERNATIONAL_SHUTTLE: 'SKIPASS_INTERNATIONAL_SHUTTLE',
  SKIPASS_SUMMER: 'skipass-summer',
  SKIPASS_INTERNATIONAL_SUMMER: 'skipass-international-summer',
  SINGLERIDE_ZERMATT_FURI: 'singleride-zermatt-furi',
  RETOURRIDE_ZERMATT_FURI: 'retourride-zermatt-furi',
  SINGLERIDE_ZERMATT_SCHWARZSEE: 'singleride-zermatt-schwarzsee',
  RETOURRIDE_ZERMATT_SCHWARZSEE: 'retourride-zermatt-schwarzsee',
  SINGLERIDE_ZERMATT_TROCKENER_STEG: 'singleride-zermatt-trockener-steg',
  RETOURRIDE_ZERMATT_TROCKENER_STEG: 'retourride-zermatt-trockener-steg',
  RETOURRIDE_ZERMATT_GLACIER_PARADISE: 'retourride-zermatt-glacier-paradise',
  ENTRY_GLACIER_PALAST: 'entry-glacier-palast',
  SINGLERIDE_ZERMATT_SUNNEGGA: 'singleride-zermatt-sunnegga',
  RETOURRIDE_ZERMATT_SUNNEGGA: 'retourride-zermatt-sunnegga',
  SINGLERIDE_ZERMATT_BLAUHERD: 'singleride-zermatt-blauherd',
  RETOURRIDE_ZERMATT_BLAUHERD: 'retourride-zermatt-blauherd',
  SINGLERIDE_ZERMATT_ROTHORN: 'singleride-zermatt-rothorn',
  RETOURRIDE_ZERMATT_ROTHORN: 'retourride-zermatt-rothorn',
  COMBITICKET_GLACIER_TRAIL: 'combiticket-glacier-trail',
  COMBITICKET_5_SEENWEG_BLUMENWEG: 'combiticket-5-seenweg-blumenweg',
  ROUNDTOUR_ZERMATT_GORNERGRAT: 'roundtour-zermatt-gornergrat',
  PEAK_TO_PEAK: 'peak-to-peak',
  PEAKPASS_ZERMATT: 'peakpass-zermatt',
  COMBITICKET_NATURWEG_BLAUHERD_RIFFELALP:
    'combiticket-naturweg-blauherd-riffelalp',
  COMBITICKET_NATURWEG_SUNNEGGA_RIFFELALP:
    'combiticket-naturweg-sunnegga-riffelalp',
  BIKE_PASS_ZERMATT: 'bikepass-zermatt',
  BIKE_DAY_PASS_SUNEGGA: 'bikepass-sunnegga',
  BIKE_DAY_PASS_SUNEGGA_SCHWARZSEE: 'bikepass-sunnegga-schwarzsee',
  SKIPASS_BEGINNER: 'skipass-zermatt-beginner',
};

export default zbagTicketTypes;

export const mgbGgbTicketTypes = {
  // SINGLERIDE_SHUTTLE_ZERMATT_TASCH: 'singleride-zermatt-taesch',
  // RETOUR_SHUTTLE_ZERMATT_TASCH: 'retourride-taesch-zermatt',
  // SINGLERIDE_ZERMATT_GORNERGRAT: 'singleride-zermatt-gornergrat',
  // SINGLERIDE_TASCH_GORNERGRAT: 'singleride-taesch-gornergrat',
  // RETOUR_TASCH_GORNERGRAT: 'retourride-taesch-gornergrat',
  // SINGLERIDE_GORNERGRAT_GOURMETTICKET: 'gornergrat-gourmetticket',
  // SINGLERIDE_ZERMATT_ROTENBODEN: 'singleride-zermatt-rotenboden',
  // RETOUR_ZERMATT_ROTENBODEN: 'retourride-zermatt-rotenboden',
  // SINGLERIDE_ZERMATT_RIFFELALP: 'singleride-zermatt-riffelalp',
  // RETOUR_ZERMATT_RIFFELALP: 'retourride-zermatt-riffelalp',
  // SINGLERIDE_ZERMATT_RIFFELBERG: 'singleride-zermatt-riffelberg',
  // RETOUR_ZERMATT_RIFFELBERG: 'retourride-zermatt-riffelberg',

  SINGLERIDE_ZERMATT_GORNERGRAT: 'singleride-zermatt-gornergrat',
  RETOURRIDE_ZERMATT_GORNERGRAT: 'retourride-zermatt-gornergrat',
  SINGLERIDE_GORNERGRAT_ZERMATT: 'singleride-gornergrat-zermatt',
  SINGLERIDE_ZERMATT_RIFFELALP: 'singleride-zermatt-riffelalp',
  SINGLERIDE_RIFFELALP_ZERMATT: 'singleride-riffelalp-zermatt',
  RETOURRIDE_ZERMATT_RIFFELALP: 'retourride-zermatt-riffelalp',
  SINGLERIDE_ZERMATT_RIFFELBERG: 'singleride-zermatt-riffelberg',
  SINGLERIDE_RIFFELBERG_ZERMATT: 'singleride-riffelberg-zermatt',
  RETOURRIDE_ZERMATT_RIFFELBERG: 'retourride-zermatt-riffelberg',
  SINGLERIDE_ZERMATT_ROTENBODEN: 'singleride-zermatt-rotenboden',
  SINGLERIDE_ROTENBODEN_ZERMATT: 'singleride-rotenboden-zermatt',
  RETOURRIDE_ZERMATT_ROTENBODEN: 'retourride-zermatt-rotenboden',
  SINGLERIDE_GORNERGRAT_AFTERNOON: 'afternoon-zermatt-gornergrat',
  SINGLERIDE_TAESCH_GORNERGRAT: 'singleride-taesch-gornergrat',
  RETOURRIDE_TAESCH_GORNERGRAT: 'retourride-taesch-gornergrat',
  SINGLERIDE_TAESCH_ZERMATT: 'singleride-taesch-zermatt',
  RETOURRIDE_TAESCH_ZERMATT: 'retourride-taesch-zermatt',
  SINGLERIDE_ZERMATT_TAESCH: 'singleride-zermatt-taesch',
  SINGLERIDE_GORNERGRAT_GOURMETTICKET: 'gornergrat-gourmetticket',
};

export const ReturnTicketTypes = [
  'RETOURRIDE_ZERMATT_FURI',
  'RETOURRIDE_ZERMATT_SCHWARZSEE',
  'RETOURRIDE_ZERMATT_TROCKENER_STEG',
  'RETOURRIDE_ZERMATT_SUNNEGGA',
  'RETOURRIDE_ZERMATT_BLAUHERD',
  'RETOURRIDE_ZERMATT_ROTHORN',
  'RETOURRIDE_ZERMATT_GORNERGRAT',
  'RETOURRIDE_ZERMATT_RIFFELALP',
  'RETOURRIDE_ZERMATT_RIFFELBERG',
  'RETOURRIDE_ZERMATT_ROTENBODEN',
  'RETOURRIDE_TAESCH_GORNERGRAT',
  'RETOURRIDE_TAESCH_ZERMAT',
  'RETOURRIDE_ZERMATT_GLACIER_PARADISE',
  'COMBITICKET_GLACIER_TRAIL',
  'COMBITICKET_5_SEENWEG_BLUMENWEG',
  'COMBITICKET_NATURWEG_SUNNEGGA_RIFFELALP',
];



// WEBPACK FOOTER //
// ./src/views/skidata/components/ticketTypes.js